export const reconciliationCategoryNames = {
  WrongRate: 'Wrong rate',
  WrongDate: 'Wrong date',
  WrongGuestDetails: 'Wrong guest details',
  RepeatGuest: 'Repeat guest',
  NotDirectBooking: 'Not a direct booking',
  FriendsOrFamily: 'Friends & family',
  CancelledOrNoShow: 'Cancelled/No show',
  Other: 'Other'
}
